import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { useHistory } from 'react-router-dom';
import SaveIcon from '@material-ui/icons/Save';
import {
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Grid,
    Divider,
    Switch,
    TextField,
    Typography,
    colors
} from '@material-ui/core';


const useStyles = makeStyles(theme => ({
    root: {},

    saveButton: {
        color: theme.palette.white,
        backgroundColor: colors.green[600],
        '&:hover': {
            backgroundColor: colors.green[900]
        },

    },

    flexend: {
        justifyContent: 'flex-end',
    },
    leftIcon: {
        marginRight: theme.spacing.unit,
    },
}));

export default function From(props) {

    const { profile, className, ...rest } = props;

    const classes = useStyles();

    const [openSnackbar, setOpenSnackbar] = useState(false);

    const [values, setValues] = useState({
        // firstName: profile.firstName,
        // lastName: profile.lastName,
        // email: profile.email,
        // phone: profile.phone,
        // state: profile.state,
        // country: profile.country,
        // isPublic: profile.isPublic,
        // canHire: profile.canHire
    });

    const history = useHistory();

    const agents = ['Agent001', 'Agent002'];

    const handleChange = event => {
        event.persist();

        setValues({
            ...values,
            [event.target.name]:
                event.target.type === 'checkbox'
                    ? event.target.checked
                    : event.target.value
        });
    };

    const handleSubmit = event => {
        // event.preventDefault();
        // setOpenSnackbar(true);
        // history.push("/appointment");
        event.preventDefault();

        const postparam = {
            pax: values.pax,
            agent_id: values.agent_id,
            property_id: values.property_id,
            date: values.date,
            start_time: values.start_time,
            end_time: values.end_time,
        };
        let body = '';
        for (let k in postparam) {
            body += encodeURI(k) + "=" + encodeURI(postparam[k]) + "&";
        }

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: body
        }
    };

    const handleSnackbarClose = () => {
        setOpenSnackbar(false);
    };


    return (
        <Card
            {...rest}
            className={clsx(classes.root, className)}
        >
            <form onSubmit={handleSubmit}>
                <CardHeader title="Create New Appointment" />
                <Divider />
                <CardContent>
                    <Grid
                        container
                        spacing={4}
                    >
                        <Grid
                            item
                            md={6}
                            xs={12}
                        >
                            <TextField
                                fullWidth
                                label="Slots"
                                name="slots"
                                onChange={handleChange}
                                value={values.slots}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={12}
                        >
                            <TextField
                                fullWidth
                                label="Agent"
                                name="agent"
                                onChange={handleChange}
                                select
                                // eslint-disable-next-line react/jsx-sort-props
                                SelectProps={{ native: true }}
                                required
                                value={values.agent}
                                variant="outlined"
                            >
                                {agents.map(agent => (
                                    <option
                                        key={agent}
                                        value={agent}
                                    >
                                        {agent}
                                    </option>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={12}
                        >
                            <TextField
                                fullWidth
                                label="Start Date"
                                name="startdate"
                                onChange={handleChange}
                                type="datetime-local"
                                value={values.startdate}
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />

                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={12}
                        >
                            <TextField
                                fullWidth
                                label="End Date"
                                name="enddate"
                                onChange={handleChange}
                                type="datetime-local"
                                value={values.enddate}
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />

                        </Grid>


                    </Grid>
                </CardContent>
                <Divider />
                <CardActions className={classes.flexend}>
                    <Button
                        className={classes.saveButton}
                        type="submit"
                        variant="contained"

                    >
                        <SaveIcon className={classes.leftIcon} />
                    Save Changes
                </Button>
                </CardActions>
            </form>
            {/* <SuccessSnackbar
            onClose={handleSnackbarClose}
            open={openSnackbar}
            /> */}
        </Card>
    )
}

